import { ResolveFn } from '@angular/router';

export const serverTimeResolver: ResolveFn<Promise<{ status: true; data: number }>> = (route, state) => {
	return Promise.resolve({ status: true, data: Date.now() });
};
